import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { EffectsModule } from "@ngrx/effects";
import { KeycloakDataAccessModule } from "@youm-front/keycloak/data-access";
import { AccountAuthEffects } from "./+state/effects";
import { AccountAuthFacade } from "./+state/facades";

// This module encapsulates the work with the 3-rd party auth libraries.
// The approach, to separate this logic in a separate module, allows
// to use the Account module in several apps without including authentication logic,
// that, probably, should be included to the one app only.

@NgModule({
  imports: [
    CommonModule,
    KeycloakDataAccessModule.withProviders(),
    EffectsModule.forFeature([AccountAuthEffects])
  ],
  providers: [AccountAuthFacade]
})
export class AccountAuthDataAccessModule {}
